import { useEffect, forwardRef, useImperativeHandle, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

import { userState } from "../interface/MainInterface";
import { Box, Drawer } from "@mui/material";

import { HttpUnAuthApi } from "../interface/unauth-api";
import { CommonUtils } from "../utils/common_utils";
import dayjs from "dayjs";

interface propsType {
  userState: userState;
}

const unAuthAPI = new HttpUnAuthApi();
const cUtils = new CommonUtils();

const SearchModal = (props: propsType, ref: any) => {
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const [hotKeywords, setHotKeywords] = useState<any>([]);
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    get_keyword_list();
    return () => {
      setOpenModal(false);
      setHotKeywords([]);
      setSearchText("");
    };
  }, []);

  const open = () => {
    setOpenModal(true);
  };

  const close = () => {
    setSearchText("");
    setOpenModal(false);
  };

  const get_keyword_list = async () => {
    const param: any = {
      command: "get_keyword_list",
      gubun: "keyword_count",
      category: "all",
    };

    // 검색 조건별 날짜 세팅
    // 3일전
    const from_dtm = dayjs().subtract(1, "day").format("YYYYMMDD");
    const to_dtm = dayjs().add(1, "day").format("YYYYMMDD");
    param.from_dtm = from_dtm;
    param.to_dtm = to_dtm;

    const res = await unAuthAPI.post(param);
    if (res.code === "200") {
      const result = _make_keyword_list(res.response.keyword_list);
      setHotKeywords(result);
    } else {
      console.error("[ERROR] get_keyword_list : ", res.response.error_msg);
    }
  };

  // 키워드별 머지 및 정렬(많은 히트수)
  const _make_keyword_list = (list: any) => {
    let result = cUtils.mergeJsonList(list, "pk", "count");
    result = cUtils.jsonListSort(result, "count");

    let temp: any = [];
    for (const key of result) {
      if (temp.length > 15) break;
      const keyword = key.pk.split("#")[1];
      if (temp.includes(keyword)) continue;
      else temp.push(keyword);
    }

    return temp;
  };

  const search = () => {
    navigate(`/search?key=${searchText}`);
    close();
  };

  // 부모 Component에서 접근 가능하도록 함수 전달.
  useImperativeHandle(ref, () => ({
    open,
  }));

  return (
    <Drawer
      PaperProps={{
        elevation: 0,
      }}
      anchor="top"
      open={openModal}
      onClose={close}
    >
      <Box
        sx={{
          width: "100%",
          position: "relative",
        }}
      >
        <div className="modal-content">
          <span id="closeModalBtn" className="modal-close" title="닫기" onClick={close}></span>
          <div>
            <dl className="search-wrap">
              <dt>키워드 검색</dt>
              <dd>
                <input
                  type="text"
                  placeholder="어떤 키워드로 검색할까요?"
                  value={searchText}
                  onChange={(e) => {
                    setSearchText(e.target.value);
                  }}
                  onKeyUp={(e) => {
                    if (e.key === "Enter") {
                      search();
                    }
                  }}
                  autoFocus
                />
                <button className="btn-search-modal" title="검색하기" onClick={search}></button>
              </dd>
            </dl>
            <dl className="hotkw-list">
              <dt>실시간 HOT 키워드</dt>
              <dd>
                {hotKeywords.map((keyword: string, index: number) => (
                  <button
                    key={`hot-key=${index}`}
                    onClick={() => {
                      setSearchText(keyword);
                    }}
                  >
                    {keyword}
                  </button>
                ))}
              </dd>
            </dl>
          </div>
        </div>
      </Box>
    </Drawer>
  );
};

export default forwardRef(SearchModal);
